var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBalloonGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.899,
    height: 74.76,
    viewBox: "0 0 29.899 74.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-85.637 -338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.351,42.873c1.879.647,2.328,3.209,1.682,5.088s-2.015,3.437-2.7,5.3a15.882,15.882,0,0,0-.674,2.889,24.177,24.177,0,0,0-.485,7.069,20.1,20.1,0,0,0,2.2,6.344A59.348,59.348,0,0,0,40.453,80.5",
    transform: "translate(66.683 331.948)",
    fill: "none",
    stroke: "#2f2e41",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,14.949c0,8.256,6.693,21.433,14.949,21.433S46.9,23.206,46.9,14.949a14.949,14.949,0,0,0-29.9,0Z",
    transform: "translate(68.637 338)",
    fill: "#16c1c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.637,13.213c-1.741,0-3.152-1.693-3.152-3.782S24.9,5.648,26.637,5.648s3.152,1.693,3.152,3.782S28.378,13.213,26.637,13.213Z",
    transform: "translate(67.736 337.215)",
    fill: "#fff",
    opacity: 0.4
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalloonGreen);
export default __webpack_public_path__ + "static/media/balloon_green.3d56113ca221bf673269958e5ce49c28.svg";
export { ForwardRef as ReactComponent };